enum BenefitsActions {
    FETCH_SETTINGS = "benefitsFetchSettings",
    CREATE_SETTING = "benefitsCreateSetting",
    UPDATE_SETTING = "benefitsUpdateSetting",
    DELETE_SETTING = "benefitsDeleteSetting",
    FETCH_TOPICS = "benefitsFetchTopics",
    CREATE_TOPIC = "benefitsCreateTopic",
    UPDATE_TOPIC = "benefitsUpdateTopic",
    DELETE_TOPIC = "benefitsDeleteTopic",
    REORDER_TOPICS = "benefitsReorderTopics",
}

enum BenefitsMutation {
    SET_SETTINGS_RESULT = "benefitsSettingsResult",
    SET_TOPICS_RESULT = "benefitsTopicsResult",
}

export { BenefitsActions, BenefitsMutation };
